import { INVENTORY_ITEM_CATEGORY_ID_TYPES } from 'src/types/itemInventory';

import type { SubscriptionAction } from './getSubscriptionAction';

type TextKeyFn = (isCore: boolean) => string;

/**
 * Shop & Guide 화면에서 구독 버튼의 번역키를 반환한다.
 *
 * [구독 없음]
 * - Core 카드: 구독하기
 * - Max 카드: 구독하기
 *
 * [앱 구독 중]
 * - Core 카드: 다른 계정으로 구독 중
 * - Max 카드: 다른 계정으로 구독 중
 *
 * [Core renew on]
 * - Core 카드: Core 구독 중 (disabled)
 * - Max 카드: 업그레이드
 *
 * [Core renew off]
 * - Core 카드: 갱신하기
 * - Max 카드: 업그레이드
 *
 * [Max renew on]
 * - Core 카드: Max 구독 중 (disabled)
 * - Max 카드: Max 구독 중 (disabled)
 *
 * [Max renew off]
 * - Core 카드: 구독하기
 * - Max 카드: 갱신하기
 */
const TEXT_KEYS: Record<SubscriptionAction, TextKeyFn> = {
  new: (isCore) => (isCore ? 'shop.subs_core_subscribe' : 'shop.subs_max_subscribe'),
  upgrade: () => 'subs_core_select_max_cta',
  downgrade: (isCore) => (isCore ? 'shop.subs_core_subscribe' : 'shop.subs_max_subscribe'),
  renew: () => 'subs_common_renew_cta',
  alreadySubscribed: (isCore) => (isCore ? 'subs_core_subscribed_cta' : 'subs_max_subscribed_cta'),
  subscribedOnApp: () => 'subs_core_otheraccount_cta',
  alreadyOnHigherPlan: () => 'subs_max_subscribed_cta',
};

export const getSubscriptionButtonTextKey = (
  action: SubscriptionAction,
  planId: string
): string => {
  const isCore = planId === INVENTORY_ITEM_CATEGORY_ID_TYPES.AZAR_CORE;
  return TEXT_KEYS[action](isCore);
};
